module.exports = __webpack_public_path__ + "static/media/WhiskersWhimsiesIcon.79bf47ed.png";